<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/"> Home </router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/setting/index"> Setting </router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/roster/pattern/index"> Roster Setting </router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Create Pattern
      </h6>

      <div style="padding-bottom: 100px" class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow-sm roster-pattern-card">
          <div class="card-body">
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
              <div>
                <div class="roster-pattern-title">Create Pattern</div>
                <div class="roster-pattern-subtitle">Add a new roster pattern for use in the roster builder.</div>
              </div>
              <button class="btn btn-outline-primary bdr-rad" @click="$router.push('/roster/pattern/index')">Back to Manage Pattern</button>
            </div>

            <div class="roster-pattern-shell">
              <div class="roster-pattern-shell-title">Create Pattern</div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="custom-label">Pattern Code</label>
                  <input v-model="patternForm.pattern_code" type="text" class="form-control bdr-rad font-size_def" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="custom-label">Status</label>
                  <select v-model="patternForm.status" class="form-control bdr-rad font-size_def">
                    <option :value="1">Active</option>
                    <option :value="0">Inactive</option>
                  </select>
                </div>
                <div class="col-md-12 mb-3">
                  <label class="custom-label">Pattern Name *</label>
                  <input v-model="patternForm.pattern_name" type="text" class="form-control bdr-rad font-size_def" />
                </div>
                <div class="col-md-12 mb-3">
                  <label class="custom-label">Pattern Description</label>
                  <textarea v-model="patternForm.pattern_description" rows="6" class="form-control bdr-rad font-size_def"></textarea>
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <button class="btn btn-outline-secondary bdr-rad mr-2" @click="resetForm">Reset</button>
                <button class="btn btn-primary bdr-rad" :disabled="saving" @click="submitPattern">
                  {{ saving ? "Saving..." : "Save Pattern" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      userid: authService.isUserid(),
      saving: false,
      suggestedPatternCode: "",
      patternId: 0,
      patternForm: {
        pattern_code: "",
        pattern_name: "",
        pattern_description: "",
        status: 1,
      },
    };
  },
  mounted() {
    this.loadMasterData();
  },
  computed: {
    isEditMode() {
      return this.patternId > 0;
    },
  },
  methods: {
    rosterRequestHeaders() {
      return {
        Authorization: "Bearer " + this.access_token,
        "Content-Type": "application/json",
      };
    },
    async loadMasterData() {
      try {
        const { data } = await axios.get("/roster/masterdata", { headers: this.rosterRequestHeaders() });
        this.suggestedPatternCode = data.suggested_codes && data.suggested_codes.pattern_code ? data.suggested_codes.pattern_code : "";
        const query = this.$route && this.$route.query ? this.$route.query : {};
        this.patternId = query.id ? parseInt(query.id, 10) || 0 : 0;
        if (query.pattern_code) {
          this.patternForm.pattern_code = query.pattern_code;
          this.patternForm.pattern_name = query.pattern_name || "";
          this.patternForm.pattern_description = query.pattern_description || "";
          if (query.status !== undefined) {
            this.patternForm.status = parseInt(query.status, 10) === 0 ? 0 : 1;
          }
        } else if (!this.patternForm.pattern_code) {
          this.patternForm.pattern_code = this.suggestedPatternCode;
        }
      } catch (error) {
        console.log(error.response || error);
      }
    },
    resetForm() {
      this.patternForm = {
        pattern_code: this.suggestedPatternCode || "",
        pattern_name: "",
        pattern_description: "",
        status: 1,
      };
      this.patternId = 0;
    },
    async submitPattern() {
      if (!this.patternForm.pattern_name) return;
      this.saving = true;
      try {
        const url = this.isEditMode ? "/roster/updatepattern" : "/roster/createpattern";
        const payload = {
          userid: this.userid,
          pattern: Object.assign({ id: this.patternId }, this.patternForm),
        };
        const { data } = await axios.post(url, payload, { headers: this.rosterRequestHeaders() });
        if (data.status === 200) {
          this.resetForm();
          this.$router.push("/roster/pattern/index");
        }
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.roster-pattern-card {
  border-radius: 16px;
}

.roster-pattern-title {
  font-size: 20px;
  font-weight: 700;
  color: #0c3d89;
}

.roster-pattern-subtitle {
  font-size: 13px;
  color: #5b6472;
}

.roster-pattern-shell {
  border: 1px solid #d8e3f0;
  border-radius: 14px;
  background: #fff;
  padding: 14px;
}

.roster-pattern-shell-title {
  font-weight: 700;
  color: #0c3d89;
  margin-bottom: 12px;
}

@media (max-width: 767.98px) {
  .roster-pattern-shell {
    padding: 12px;
  }

  .roster-pattern-title {
    font-size: 18px;
  }
}
</style>
